import {Component, EventEmitter, Input, OnInit, Output, Type} from '@angular/core';
import {Router} from '@angular/router';

import {DefaultHelpComponent} from './content/default-help.component';
import {resolveHelpContent} from './help-content.registry';

/**
 * The chrome for every page's help: one dialog, one Okay button, one scrolling
 * body. The page-specific text comes from a content component looked up by
 * route, so adding help for a screen never means touching this file.
 */
@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent implements OnInit {
    @Input() pageTitle: string;
    @Output() closed = new EventEmitter<void>();

    public content: Type<any>;
    public hasContent = false;

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        const resolved = resolveHelpContent(this.router.url);
        this.hasContent = !!resolved;
        this.content = resolved || DefaultHelpComponent;
    }

    public get title(): string {
        return this.pageTitle ? `How ${this.pageTitle} Works` : 'Help';
    }

    public onClose(): void {
        this.closed.emit();
    }
}
